BigInt.prototype['toJSON'] = function () {
  return this.toString();
};

export const objectsMatch = <T>(obj1: T, obj2: T, fieldsToIgnore: string[] = [], falsy = true) => {
  if (!obj1 || !obj2) return false;
  const matchedKey = Object.keys(obj1).find(key => {
    if (fieldsToIgnore.includes(key)) return;
    if (typeof obj1[key] === 'object' && obj1[key] !== null) {
      return JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key]);
    }
    if (falsy && !obj1[key] && !obj2[key]) return;
    return obj1[key] !== obj2[key];
  });

  if (matchedKey) {
    // console.debug(matchedKey, '"' + obj1[matchedKey] + '"', '"' + obj2[matchedKey] + '"');
    return false;
  }

  const matchedKey2 = Object.keys(obj2).find(key => {
    if (fieldsToIgnore.includes(key)) return;
    if (typeof obj2[key] === 'object' && obj2[key] !== null) {
      return JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key]);
    }
    if (falsy && !obj1[key] && !obj2[key]) return;
    return obj1[key] !== obj2[key];
  });

  if (matchedKey2) {
    // console.debug(matchedKey2, '"' + obj1[matchedKey2] + '"', '"' + obj2[matchedKey2] + '"');
    return false;
  }

  return true;
};
